<template>
  
  <div class="min-h-dvh w-full flex flex-col bg-slate-50">

    


    <main class="flex-1 flex flex-col">
      <div class="flex justify-end p-4">
      <LanguageSelect />
    </div>
      <div class="w-full mx-auto max-w-md px-4 py-6">
        <router-view />
      </div>
    </main>

  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import LanguageSelect from '@/components/LanguageSelect.vue'
const { locale } = useI18n()
</script>

<style scoped>
/* Ensure the html/body doesn't have a fixed height that conflicts */
:global(html, body) {
  height: auto;
  min-height: 100%;
  background-color: #f8fafc; /* Matches bg-slate-50 */
}
</style>